import { ofType } from "redux-observable";
import { of } from "rxjs";
import { switchMap, take } from "rxjs/operators";
import { mapOutskirtsPosition } from "../scenes/mapOutskirtsPosition";
import { actionViewportCenterOn } from "../viewport/actionViewport";
import { TypeActionActionButton, } from "./actionHudActionButton";
export var epicHudActionButtonFocusBuilding = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionActionButton.FocusOutskirtsBuilding), switchMap(function (action) {
        var position = mapOutskirtsPosition.get(action.outskirtBuildingId);
        return deps.inStoreDependencies.viewportChanged$.pipe(take(1), switchMap(function (viewport) {
            return of(actionViewportCenterOn(viewport.toGlobal(position)));
        }));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/hud-action-button/epicHudActionButtonFocusBuilding.ts
// module id = 1892
// module chunks = 3